import React from "react";
import { createRoot } from "react-dom/client";
// Belgian number separators (1.234,5) for numeral, d3 and Observable Plot: set before anything renders
import "./helpers/locale";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import mapboxgl from "mapbox-gl";

import "./assets/fonts/NimbusSanL-Reg.otf";
import "./fonts.css";
import "./index.css";

// eslint-disable-next-line
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// No offline mode: a service worker kept serving the previous deploy until every tab was closed.
// unregister() removes the one earlier versions installed (public/service-worker.js retires it too).
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
